import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Sidebar from './components/Sidebar/Sidebar';
import LanguageBar from './components/LanguageBar/LanguageBar';
import UseCustomerSettingsCheckBox from './components/UseCustomerSettingsCheckBox/UseCustomerSettingsCheckBox';
import StyleFields from 'components/StyleFields/StyleFields';
import MediaFields from './components/MediaFields/MediaFields';
import DocumentSettings from './components/DocumentSettings/DocumentSettings';
import AdditionalSettings from './components/AdditionalSettings/AdditionalSettings';
import NoData from 'components/NoResultsFound/NoData';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { UserRoles } from 'types';
import classNames from 'classnames';
import style from './StyleTab.module.scss';

const StyleTab: React.FC = () => {
	const { styleData, restaurantFullInfoVisibleForm, selectedStyleGroup } =
		useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);
	const hasAdditionalSettingsAccess = useRoleAccess([
		UserRoles.SUPER_USER,
		UserRoles.RESTAURANT_MANAGER,
		UserRoles.TECHNICAL,
	]);
	const containerClasses = classNames(style.container, {
		[style.visible]: restaurantFullInfoVisibleForm === 'styleForm',
	});

	// TODO delete later
	const functionStub = () => {
		console.log();
	};
	// TODO delete later

	return (
		<div className={containerClasses} data-test="StyleTab">
			{styleData ? (
				<>
					{styleData.mediaSettings.length ? (
						<>
							<div className={style.sidebar}>
								<Sidebar />
							</div>
							<div className={style.content}>
								<div className={style.languageBar}>
									<LanguageBar />
								</div>
								<div className={style.fieldsWrapper}>
									<Text
										translationNameSpace="mediaSettings"
										translationKey="customerSettingsLabel"
										theme="secondary"
										size="l"
										weight="bold"
									/>
									<UseCustomerSettingsCheckBox
										isUseCustomerSettings={styleData.useCustomerSettings}
									/>
								</div>
								<div className={style.inputsWrapper}>
									<StyleFields
										selectedGroup={selectedStyleGroup}
										setStyleSettings={functionStub}
										styleSettingColors={styleData.styleSettingColors}
										useForFullInfo={true}
									/>
								</div>
								<div className={style.inputsWrapper}>
									{styleData?.mediaSettings.map((el) => (
										<MediaFields data={el} key={el.languageId} />
									))}
								</div>
								{styleData.documentSettings.map((el) => (
									<div className={style.fieldsWrapper} key={el.key}>
										<DocumentSettings data={el} />
									</div>
								))}
								{hasAdditionalSettingsAccess && (
									<div className={style.fieldsWrapper}>
										<Text
											translationNameSpace="mediaSettings"
											translationKey="additional_setting_file"
											theme="secondary"
											size="l"
											weight="bold"
										/>
										<AdditionalSettings />
									</div>
								)}
							</div>
						</>
					) : (
						<NoData />
					)}
				</>
			) : null}
		</div>
	);
};

export default StyleTab;
